import colors from './colors'; // const breakpoints = [32, 48, 64].map(b => `${b}em`);
// follow Primer breakpoints

var breakpoints = ['544px', '768px', '1012px', '1280px']; // alias

breakpoints.sm = breakpoints[0];
breakpoints.md = breakpoints[1];
breakpoints.lg = breakpoints[2];
breakpoints.xl = breakpoints[3];
var maxWidth = {
  sm: breakpoints[0],
  md: breakpoints[1],
  lg: breakpoints[2],
  xl: breakpoints[3]
};
var spaces = [0, 4, 8, 12, 16, 20, 24, 32, 48, 64, 128];
var fontSizes = [12, 14, 16, 18, 20, 24, 28, 36, 48, 60, 96];
var lineHeights = {
  normal: 'normal',
  none: 1,
  shorter: 1.25,
  "short": 1.375,
  base: 1.5,
  tall: 1.625,
  taller: 2
};
var fontWeights = {
  hairline: 100,
  thin: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900
};
var letterSpacings = {
  tighter: '-0.05em',
  tight: '-0.025em',
  normal: '0',
  wide: '0.025em',
  wider: '0.05em',
  widest: '0.1em'
};
var theme = {
  breakpoints: breakpoints,
  colors: colors,
  maxWidth: maxWidth,
  space: spaces,
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  lineHeights: lineHeights,
  letterSpacings: letterSpacings,
  textStyles: {
    header1: {
      fontSize: fontSizes[10],
      fontWeight: fontWeights.medium
    },
    header2: {
      fontSize: fontSizes[9],
      fontWeight: fontWeights.medium
    },
    header3: {
      fontSize: fontSizes[8],
      fontWeight: fontWeights.medium
    },
    header4: {
      fontSize: fontSizes[7],
      fontWeight: fontWeights.medium
    },
    header5: {
      fontSize: fontSizes[6],
      fontWeight: fontWeights.medium
    },
    header6: {
      fontSize: fontSizes[5],
      fontWeight: fontWeights.medium
    },
    subtitle1: {
      fontSize: fontSizes[4],
      fontWeight: fontWeights.medium
    },
    subtitle2: {
      fontSize: fontSizes[3],
      fontWeight: fontWeights.medium
    },
    bodyBold: {
      fontSize: fontSizes[2],
      fontWeight: fontWeights.medium
    },
    body: {
      fontSize: fontSizes[2],
      fontWeight: fontWeights.normal
    },
    bodyLight: {
      fontSize: fontSizes[2],
      fontWeight: fontWeights.light
    },
    smallBold: {
      fontSize: fontSizes[1],
      fontWeight: fontWeights.medium
    },
    small: {
      fontSize: fontSizes[1],
      fontWeight: fontWeights.normal
    },
    caption: {
      fontSize: fontSizes[0],
      fontWeight: fontWeights.normal
    }
  },
  // Legacy Button Style
  buttons: {
    "default": {
      padding: '16px',
      backgroundColor: '#FBAA19',
      color: colors.white,
      '&:hover': {
        backgroundColor: '#C8840A'
      }
    },
    primaryOutline: {
      padding: '16px',
      backgroundColor: 'white',
      borderColor: '#FBAA19',
      color: '#FBAA19',
      '&:hover': {
        borderColor: '#C8840A',
        color: '#C8840A'
      }
    }
  },

  /* custom fields to use with customSystem props.
   * See /system/customSystem for a list of customSystem props.
   */
  clickableStyles: {
    link: {
      color: 'blue',
      '&:hover': {
        color: 'red'
      },
      '&:disabled': {
        color: 'yellow'
      }
    },
    boxShadow: {
      cursor: 'pointer',
      '&:hover': {
        boxShadow: '3px 3px 3px 3px grey'
      },
      '&:active': {
        boxShadow: '1px 1px 1px 1px grey'
      }
    }
  },
  // Card variants
  cardStyles: {
    "default": {
      background: 'white',
      boxShadow: '2px 2px 2px 2px grey'
    }
  },

  /* base styles for Components */
  Text: {
    fontFamily: 'Arial',
    color: '#3b3b3b',
    margin: 0
  },
  Box: {},
  Button: {
    // Clear default button style
    appearance: 'none',
    display: 'inline-block',
    textAlign: 'center',
    lineHeight: 'inherit',
    textDecoration: 'none',
    // Base style for Button
    border: '1px solid',
    borderRadius: '4px',
    '&:disabled': {
      backgroundColor: 'grey',
      borderColor: 'grey',
      color: 'white',
      '&:hover': {
        backgroundColor: 'grey',
        borderColor: 'grey',
        color: 'white'
      }
    }
  },
  Card: {},
  Flex: {},
  Image: {},
  Link: {
    textDecoration: 'none'
  }
};
export { colors, theme };
export default theme;